<script lang="ts" setup>
defineProps<{
  asChild?: boolean;
}>();
defineSlots<{
  default: (props: { class?: string }) => VNode[];
}>();
</script>

<template>
  <slot v-if="asChild" class="baseArticle" v-bind="$attrs" />
  <div v-else class="baseArticle" v-bind="$attrs"><slot /></div>
</template>

<style lang="scss">
.baseArticle {
  color: #121212;

  /* TODO: кажется этот стиль не должен быть на этом уровне */
  @include mq('lg') {
    margin-left: 0;
  }

  @include mq('sm') {
    padding-top: 24px;
    max-width: initial;
  }

  & > p,
  & > div > p {
    font-size: 16px;
    line-height: 24px;
    letter-spacing: 0.2px;
    margin-top: 0;
    margin-bottom: 40px;

    @include mq('sm') {
      font-size: 14px;
      line-height: 20px;
    }
  }

  h1 {
    font-variation-settings: 'wght' 700;
    font-size: 56px;
    line-height: 64px;
    margin-top: 0;
    margin-bottom: 36px;

    @include mq('sm') {
      font-size: 36px;
      line-height: 40px;
      margin-bottom: 24px;
    }
  }

  h2 {
    font-variation-settings: 'wght' 800;
    font-size: 28px;
    line-height: 120%;
    letter-spacing: 0.2px;
    margin-top: 0;
    margin-bottom: 24px;

    a {
      color: #121212;
    }

    @include mq('sm') {
      font-size: 24px;
      margin-bottom: 20px;
    }
  }

  h3,
  h4,
  h5,
  h6 {
    font-variation-settings: 'wght' 800;
    font-size: 20px;
    line-height: 120%;
    letter-spacing: 0.2px;
    margin-top: 0;
    margin-bottom: 24px;

    a {
      color: #121212;
    }

    @include mq('sm') {
      font-size: 18px;
      margin-bottom: 20px;
    }
  }

  ul {
    padding-left: 24px;
    margin-top: 0;
    margin-bottom: 40px;
  }

  li {
    font-size: 16px;
    line-height: 24px;
    letter-spacing: 0.2px;
  }

  em {
    font-variation-settings:
      'wght' 600,
      'ital' 1;
    font-style: italic;
  }

  hr {
    margin-top: 0;
    margin-bottom: 40px;
  }

  & > *:last-child {
    margin-bottom: 0;
  }
}
</style>
